import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Motorcycle: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m645 404.71c-7.98 0-15.75.9-23.22 2.59l-101.78-232.59c-2.28-5.69-7.79-9.41-13.92-9.41h-85c-16.57 0-30 13.43-30 30h104.86l38.94 89.41h-294.88c-16.57 0-30 13.43-30 30h309.39l-175.71 180h-104.76c-7.3-50.82-51.12-90-103.92-90-57.9 0-105 47.1-105 105s47.1 105 105 105c52.8 0 96.62-39.18 103.92-90h111.08c4.04 0 7.91-1.63 10.73-4.52l191.34-196.01 41.06 94.26c-31.71 18.09-53.13 52.22-53.13 91.27 0 57.9 47.1 105 105 105s105-47.1 105-105-47.1-105-105-105zm-510 180c-41.35 0-75-33.64-75-75s33.65-75 75-75c36.22 0 66.52 25.81 73.49 60h-73.49c-8.28 0-15 6.72-15 15s6.72 15 15 15h73.49c-6.97 34.19-37.27 60-73.49 60zm510 0c-41.35 0-75-33.64-75-75 0-26.74 14.08-50.25 35.21-63.53l33.37 76.62c15.38-6.17 22.84-23.64 16.67-39.02l-21.12-48.27c3.55-.52 7.18-.8 10.88-.8 41.35 0 75 33.64 75 75s-33.65 75-75 75z' />
  </IconBase>
));

Motorcycle.displayName = 'Motorcycle';

export default Motorcycle;
